import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { brand, navLinks } from "@/mock";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 w-full z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-black/80 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <button
          data-testid="brand-logo"
          onClick={() => handleNav("#home")}
          className="flex items-center gap-3 group"
        >
          <img
            src={brand.logo}
            alt="Bali Funeral Home"
            className="h-14 w-14 object-contain rounded-md"
          />
          <span className="hidden sm:block text-left leading-tight">
            <span className="block font-serif text-lg text-[#F5F5F5] tracking-[0.15em]">
              BALI
            </span>
            <span className="block text-[0.6rem] tracking-[0.3em] uppercase text-[#D4AF37]">
              Funeral Home
            </span>
          </span>
        </button>

        <div className="hidden md:flex items-center gap-10">
          {navLinks.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-${l.href.replace("#", "")}`}
              onClick={() => handleNav(l.href)}
              className="text-sm tracking-wide text-gray-300 hover:text-[#D4AF37] transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <a
            data-testid="nav-call-btn"
            href={`tel:+${brand.whatsapp}`}
            className="inline-flex items-center gap-2 border border-[#D4AF37] text-[#D4AF37] px-5 py-2.5 rounded-full text-sm tracking-wide hover:bg-[#D4AF37] hover:text-black transition-colors duration-300"
          >
            <Phone size={16} strokeWidth={1.5} />
            Telefononi Tani
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-[#F5F5F5]"
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-black/95 backdrop-blur-xl border-t border-white/10 px-6 py-6 flex flex-col gap-5"
        >
          {navLinks.map((l) => (
            <button
              key={l.href}
              data-testid={`mobile-nav-${l.href.replace("#", "")}`}
              onClick={() => handleNav(l.href)}
              className="text-left text-base text-gray-200 hover:text-[#D4AF37] transition-colors"
            >
              {l.label}
            </button>
          ))}
          <a
            href={`tel:+${brand.whatsapp}`}
            className="inline-flex items-center justify-center gap-2 border border-[#D4AF37] text-[#D4AF37] px-5 py-3 rounded-full text-sm"
          >
            <Phone size={16} strokeWidth={1.5} />
            Telefononi Tani
          </a>
        </div>
      )}
    </header>
  );
};
